import { render, staticRenderFns } from "./sell-detail.vue?vue&type=template&id=f1dafb7c&scoped=true"
import script from "./sell-detail.vue?vue&type=script&lang=js"
export * from "./sell-detail.vue?vue&type=script&lang=js"
import style0 from "./sell-detail.vue?vue&type=style&index=0&id=f1dafb7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dafb7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1dafb7c')) {
      api.createRecord('f1dafb7c', component.options)
    } else {
      api.reload('f1dafb7c', component.options)
    }
    module.hot.accept("./sell-detail.vue?vue&type=template&id=f1dafb7c&scoped=true", function () {
      api.rerender('f1dafb7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/components/sell-detail.vue"
export default component.exports